import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const StyledBackButton = styled.button`
  position: absolute;
  left: ${space[5]};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(${space[7]} + ${space[1]});
  height: calc(${space[6]} + ${space[2]});
  border-radius: ${space[5]};
  border: none;
  cursor: pointer;
  padding: 0;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &[data-variant='default'] {
    border: 1px solid ${colors.borderGrey};
    background: ${colors.white};

    &:hover {
      background: ${colors.lighterGrey};
    }
  }

  &[data-variant='overlay'] {
    background: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(${space[2]});
    top: auto;
    transform: none;

    &:focus-visible {
      outline-color: ${colors.white};
    }

    svg {
      width: ${fonts.size.lg};
      height: ${fonts.size.lg};
      color: ${colors.white};
    }
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    left: ${space[7]};
  }
`;
